import assign from "lodash/fp/assign";
import apis from "../../core/apis.js";

class VariablePlanResource {
  constructor($resource) {
    "ngInject";

    this.$resource = $resource;
  }

  getAll(options) {
    return this.$resource(apis.variablePlan).get(options);
  }

  get(id) {
    return this.$resource(apis.variablePlan + id).get();
  }

  search(name = "", params) {
    return this.$resource(apis.variablePlan).get(assign(params, { name }));
  }

  post(item) {
    return this.$resource(apis.variablePlan).save(item);
  }

  update(id, item) {
    return this.$resource(apis.variablePlan + id, null, {
      update: { method: "PATCH" },
    }).update(item);
  }
}

export default VariablePlanResource;



// WEBPACK FOOTER //
// ./src/resources/variablePlan/variablePlan.resource.js